import React, {Component} from "react";
import withFormGroup from "../../../../modules/commons/withFormGroup";
import SimpleModal from "../../../../modules/popup/SimpleModal";
import ModalContainer from "../../../../modules/commons/ModalContainer";
import {satuan} from "../config";
import SimpleInput from "../../../../modules/SimpleInput";
import FlexView from "react-flexview";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import SimpleCheckBox from "../../../../modules/SimpleCheckBox";
import {ACTIVITY_TYPE, Status} from "../../../common/Constants";
import SimpleDDL from "../../../../modules/SimpleDDL";
import SimpleDataTable from "../../../../modules/SimpleDataTable";
import * as R from "ramda";
import SimpleDate from "../../../../modules/SimpleDate";
import M from "moment";
import SimpleUploadImage from "../../../../modules/upload/SimpleUploadImage";
import ToggleButton from "react-toggle-button";
import SimpleAlert from "../../../../modules/popup/SimpleAlert";
import {mapToObjectDDL} from "../../../common/mapper";
import {FormatCurrencyWithoutSymbol} from "../../../../Services/Utils";
import Api from "../../../../Services/Api";

class MasterVoucherModifying extends Component {
    tableConfigListSubType = {
        part: [
            {
                name: "jobPartCode",
                label: "Kode Part",
                options: {
                    customBodyRender: (val, {rowIndex}) => {
                        let saved = this.props.controls.spesificJobPart?.value?.[rowIndex].saved;
                        if (saved) {
                            return <>{val}</>;
                        }
                        return <>
                            <SimpleDDL
                                id="select_options_kode_part"
                                name="kodePart"
                                box="search"
                                value={!R.isNil(this.props.controls.spesificJobPart?.value[rowIndex]?.jobPartCode)
                                    ? mapToObjectDDL(
                                        this.props.controls.spesificJobPart?.value[rowIndex]?.jobPartCode,
                                        this.props.controls.spesificJobPart?.value[rowIndex]?.jobPartCode)
                                    : null}
                                options={this.props.options.partOptions.map(item => mapToObjectDDL(item.kodePart, item.kodePart))}
                                onChange={(value) => this.handleChangePart(value.value, rowIndex)}
                                readOnly={this.state.viewOnly}
                            />
                        </>
                    }
                },
            },
            {
                name: "partName",
                label: "Nama Part",
                options: {
                    customBodyRender: (val, {rowIndex}) => {
                        let saved = this.props.controls.spesificJobPart?.value?.[rowIndex].saved;
                        if (saved) {
                            return <>{val}</>;
                        }
                        return <>
                            <SimpleDDL
                                id="select_options_part_name"
                                name="partName"
                                box="search"
                                value={!R.isNil(this.props.controls.spesificJobPart?.value[rowIndex]?.jobPartCode)
                                    ? mapToObjectDDL(
                                        this.props.controls.spesificJobPart?.value[rowIndex]?.partName,
                                        this.props.controls.spesificJobPart?.value[rowIndex]?.jobPartCode)
                                    : null}
                                options={this.props.options.partOptions.map(item => mapToObjectDDL(item.partName, item.kodePart))}
                                onChange={(value) => this.handleChangePart(value.value, rowIndex)}
                                readOnly={this.state.viewOnly}
                            />
                        </>
                    }
                },
            },
            {
                name: "partCategory",
                label: "Kategori Part",
                options: {
                    customBodyRender: (val, {rowIndex}) => {
                        let saved = this.props.controls.spesificJobPart?.value?.[rowIndex].saved;
                        if (saved) {
                            return <>{val}</>;
                        }
                        return <>
                            <SimpleDDL
                                id="select_options_category"
                                name="category"
                                box="search"
                                value={mapToObjectDDL(
                                    this.props.controls.spesificJobPart?.value[rowIndex]?.partCategory,
                                    this.props.controls.spesificJobPart?.value[rowIndex]?.partCategory,
                                ) || null}
                                options={this.props.options.partOptions.map(item => mapToObjectDDL(item.value, item.key))}
                                onChange={(value) => this.handleChangeCategory(value.value, rowIndex)}
                                readOnly={true}
                            />
                        </>
                    }
                },
            },
            {
                name: "unit",
                label: "Satuan",
                options: {
                    customBodyRender: (val, {rowIndex}) => {
                        let saved = this.props.controls.spesificJobPart?.value?.[rowIndex].saved;
                        if (saved) {
                            return <>{val}</>;
                        }
                        return <>
                            <SimpleDDL
                                id="select_options_satuan"
                                name="satuan"
                                box="search"
                                value={this.state.satuanOptions.find(item => item.value === val) || null}
                                options={this.state.satuanOptions}
                                onChange={(value) => this.handleChangeSatuan(value.value, rowIndex)}
                                readOnly={this.state.viewOnly}
                            />
                        </>
                    }
                },
            },
            {
                name: "value",
                label: "Nilai Diskon",
                options: {
                    customBodyRender: (val, {rowIndex}) => {
                        let saved = this.props.controls.spesificJobPart?.value?.[rowIndex].saved;
                        if (saved) {
                            return <>{FormatCurrencyWithoutSymbol({number: val})}</>;
                        }
                        return <>
                            <SimpleInput
                                box="number"
                                value={FormatCurrencyWithoutSymbol({number: val})}
                                onValueChange={({value}) =>
                                    this.handleChangeDiscountValue(value, rowIndex)
                                }
                                readOnly={this.state.viewOnly}
                            />
                        </>
                    }
                },
            },
            {
                name: "saved",
                label: "Aksi",
                options: {
                    customBodyRender: (val, {rowIndex}) => {
                        if (!this.state.viewOnly) {
                            return (
                                <FlexView style={{gap: "10px"}}>
                                    {val && (
                                        <SimpleButton
                                            type="button"
                                            category="action_button"
                                            style={{backgroundColor: "transparent"}}
                                            icon={<i style={{fontSize: 20, color: "red"}}
                                                     className="fa fa-pencil-alt"/>}
                                            onClick={() => this.handleChangeSavedState(rowIndex)}
                                        />
                                    )}
                                    {!val && (
                                        <SimpleButton
                                            type="button"
                                            category="action_button"
                                            style={{backgroundColor: "transparent"}}
                                            icon={<i style={{fontSize: 20, color: "red"}} className="fa fa-save"/>}
                                            onClick={() => this.handleCheckIdJobPart(rowIndex)}
                                        />
                                    )}
                                    <SimpleButton
                                        type="button"
                                        category="action_button"
                                        style={{backgroundColor: "transparent"}}
                                        icon={<i style={{fontSize: 20, color: "red"}} className="fa fa-trash"/>}
                                        onClick={() => this.handleRemoveRow(rowIndex)}
                                    />

                                </FlexView>
                            )
                        } else {
                            return <></>;
                        }
                    }
                }
            },
        ],
        job: [
            {
                name: "kodePart",
                label: "Kode Job",
                options: {
                    customBodyRender: (val, {rowIndex}) => {
                        let saved = this.props.controls.spesificJobPart?.value?.[rowIndex].saved;
                        return <>
                            <SimpleDDL
                                id="select_options_kode_part"
                                name="kodePart"
                                box="search"
                                value={mapToObjectDDL(
                                    this.props.controls.listSubType?.value[rowIndex]?.kodePart,
                                    this.props.controls.listSubType?.value[rowIndex]?.kodePart,
                                ) || null}
                                options={this.props.options.jobOptions.map(item => mapToObjectDDL(item.kodePart, item.kodePart))}
                                onChange={(value) => this.handleChangePart(value.value, rowIndex)}
                                readOnly={this.state.viewOnly}
                            />
                        </>
                    }
                },
            },
            {
                name: "partName",
                label: "Nama Job",
                options: {
                    customBodyRender: (val, {rowIndex}) => {
                        let saved = this.props.controls.spesificJobPart?.value?.[rowIndex].saved;
                        return <>
                            <SimpleDDL
                                id="select_options_part_name"
                                name="partName"
                                box="search"
                                value={mapToObjectDDL(
                                    this.props.controls.listSubType?.value[rowIndex]?.partName,
                                    this.props.controls.listSubType?.value[rowIndex]?.kodePart,
                                ) || null}
                                options={this.props.options.jobOptions.map(item => mapToObjectDDL(item.partName, item.kodePart))}
                                onChange={(value) => this.handleChangePart(value.value, rowIndex)}
                                readOnly={this.state.viewOnly}
                            />
                        </>
                    }
                },
            },
            {
                name: "jobCategory",
                label: "Kategori Job",
                options: {
                    customBodyRender: (val, {rowIndex}) => {
                        const initialCategory = this.props.options.jobCategoryOptions
                            .find(item => item.key === val) || null;
                        return <>
                            <SimpleDDL
                                id="select_options_category"
                                name="category"
                                box="search"
                                value={!R.isNil(initialCategory) ? mapToObjectDDL(initialCategory.value, initialCategory.key) : {}}
                                options={this.props.options.jobCategoryOptions.map(item => mapToObjectDDL(item.value, item.key))}
                                onChange={(value) => this.handleChangeCategory(value.value, rowIndex)}
                                readOnly={this.state.viewOnly}
                            />
                        </>
                    }
                },
            },
            {
                name: "satuan",
                label: "Satuan",
                options: {
                    customBodyRender: (val, {rowIndex}) => {
                        return <>
                            <SimpleDDL
                                id="select_options_satuan"
                                name="satuan"
                                box="search"
                                value={val}
                                options={this.state?.satuanJobs}
                                onChange={(value) => this.handleChangeSatuan(value.value, rowIndex)}
                                readOnly={this.state.viewOnly}
                            />
                        </>
                    }
                },
            },
            {
                name: "discountValue",
                label: "Nilai Diskon",
                options: {
                    customBodyRender: (val, {rowIndex}) => {
                        return <>
                            <SimpleInput
                                box="number"
                                value={FormatCurrencyWithoutSymbol({number: val})}
                                onValueChange={({value}) =>
                                    this.handleChangeDiscountValue(value, rowIndex)
                                }
                                readOnly={this.state.viewOnly}
                            />
                        </>
                    }
                },
            },
            {
                name: "saved",
                label: "Aksi",
                options: {
                    customBodyRender: (val, {rowIndex}) => {
                        if (this.state.viewOnly)
                            return (
                                <FlexView style={{gap: "10px"}}>
                                    {val && (
                                        <SimpleButton
                                            type="button"
                                            category="action_button"
                                            style={{backgroundColor: "transparent"}}
                                            icon={<i style={{fontSize: 20, color: "red"}}
                                                     className="fa fa-pencil-alt"/>}
                                            // onClick={() => this.handleChangeSavedState(rowIndex)}
                                        />
                                    )}
                                    {!val && (
                                        <SimpleButton
                                            type="button"
                                            category="action_button"
                                            style={{backgroundColor: "transparent"}}
                                            icon={<i style={{fontSize: 20, color: "red"}} className="fa fa-save"/>}
                                            // onClick={() => this.handleCheckVariant(rowIndex)}
                                        />
                                    )}
                                    <SimpleButton
                                        type="button"
                                        category="action_button"
                                        style={{backgroundColor: "transparent"}}
                                        icon={<i style={{fontSize: 20, color: "red"}} className="fa fa-trash"/>}
                                        // onClick={() => this.handleDeleteAlertModalVisibility(rowIndex)}
                                    />

                                </FlexView>
                            );
                    },
                }
            },
        ],
    };

    constructor(props) {
        super(props);
        this.initialErrorSubVoucher = {
            satuan: null,
            nilai: null,
            sub: null,
        };
        this.initialErrorsAvailability = {
            startDate: null,
            endDate: null,
            maxAvailable: null
        }
        this.state = {
            tableConfig: [],
            satuanOptions: satuan,
            isUndianSelected: false,
            isBengkelSelected: false,
            isJobSelected: false,
            isPartSelected: false,
            isAllSelected: false,
            isSpecificSelected: false,
            isTimedSelected: false,
            isLimitedSelected: false,
            isUnlimitedSelected: false,
            changeTypeVisible: false,
            type: null,
            viewOnly: this.props.activityType === ACTIVITY_TYPE.VIEW,
            errorsSubVoucherType: this.initialErrorSubVoucher,
            errorsAvailability: this.initialErrorsAvailability,
            alertDuplicateIdJobPart: false,
        };
    };

    componentDidMount() {
        if (this.props.activityType === ACTIVITY_TYPE.CREATE || this.props.activityType === ACTIVITY_TYPE.COPY) {
            this.getVoucherId();
        }
        if (this.props.initialValues !== null) {
            this.setState((prevValue) => ({
                ...prevValue,
                isUndianSelected: this.props.controls.voucherType.value === "UNDIAN",
                isBengkelSelected: this.props.controls.voucherType.value === "BENGKEL",
                isJobSelected: this.props.controls.subVoucherType.value === "JOB",
                isPartSelected: this.props.controls.subVoucherType.value === "PART",
                isAllSelected: this.props.controls.applicableJob.value === "ALL",
                isSpecificSelected: this.props.controls.applicableJob.value === "SPESIFIK",
                isTimedSelected: this.props.controls.availibilityVoucher.value === "TIMED",
                isLimitedSelected: this.props.controls.availibilityVoucher.value === "LIMITED",
                isUnlimitedSelected: this.props.controls.availibilityVoucher.value === "UNLIMITED",
                tableConfig: this.props.controls.subVoucherType.value === "JOB" ? this.tableConfigListSubType.job : this.tableConfigListSubType.part,
            }));
        } else {
            this.props.setValue("spesificJobPart", []);
        }
    };

    getVoucherId = async () => {
        let res = await Api.create("NAGAMAS_MASTER_DATA").getGenSeqWithoutSave({
            seqType: "MasterVoucher",
            nosDealerCode: "NOS",
            transactionType: "MasterVoucher"
        })
        if (res.ok) {
            this.props.setValue("voucherId", res.data);
        }
    };

    handleSelectVoucherType = (e, type, button) => {
        if (!R.isEmpty(this.props.controls.voucherType.value)
            && this.props.controls.voucherType.value !== type
            && !button) {
            this.setState((prevValue) => ({
                ...prevValue,
                type,
            }));
            this.handleShowAlert(false);
            return;
        }
        const isChecked = !R.isNil(e) ? e.target.checked : button;

        this.props.setValue("voucherType", type);
        this.props.setValue("spesificJobPart", [])

        if (type === "UNDIAN") {
            this.setState((prevValue) => ({
                ...prevValue,
                isUndianSelected: isChecked,
                isBengkelSelected: false,
                isJobSelected: false,
                isPartSelected: false,
                isAllSelected: false,
                isSpecificSelected: false,
            }));
        }

        if (type === "BENGKEL") {
            this.setState((prevValue) => ({
                ...prevValue,
                isBengkelSelected: isChecked,
                isUndianSelected: false,
                isJobSelected: false,
                isPartSelected: false,
                isAllSelected: false,
                isSpecificSelected: false,
            }));
        }
    };

    handleSelectVoucherSubType = (e, type) => {
        const isChecked = e.target.checked;

        this.props.setValue("subVoucherType", type);
        if (!this.props.controls.applicableJob?.value) {
            this.props.setValue("applicableJob", "ALL");
        }

        if (type === "JOB") {
            this.setState((prevValue) => ({
                ...prevValue,
                isJobSelected: isChecked,
                isAllSelected: isChecked,
                isPartSelected: false,
                isSpecificSelected: false,
                tableConfig: this.tableConfigListSubType.job,
            }));
        }

        if (type === "PART") {
            this.setState((prevValue) => ({
                ...prevValue,
                isPartSelected: isChecked,
                isAllSelected: isChecked,
                isJobSelected: false,
                isSpecificSelected: false,
                tableConfig: this.tableConfigListSubType.part,
            }));
        }
    };

    handleSelectAppliedSubType = (e, type) => {
        const isChecked = e.target.checked;

        this.props.setValue("applicableJob", type);

        if (type === "ALL") {
            this.setState((prevValue) => ({
                ...prevValue,
                isAllSelected: isChecked,
                isSpecificSelected: false,
            }));
        }

        if (type === "SPESIFIK") {
            this.setState((prevValue) => ({
                ...prevValue,
                isSpecificSelected: isChecked,
                isAllSelected: false,
            }));
        }
    };

    handleAvailability = (e, type) => {
        const isChecked = e.target.checked;

        this.props.setValue("availibilityVoucher", type);

        if (type === "TIMED") {
            this.setState((prevValue) => ({
                ...prevValue,
                isTimedSelected: isChecked,
                isLimitedSelected: false,
                isUnlimitedSelected: false,
            }));
        }

        if (type === "LIMITED") {
            this.setState((prevValue) => ({
                ...prevValue,
                isLimitedSelected: isChecked,
                isTimedSelected: false,
                isUnlimitedSelected: false,
            }));
        }

        if (type === "UNLIMITED") {
            this.setState((prevValue) => ({
                ...prevValue,
                isUnlimitedSelected: isChecked,
                isTimedSelected: false,
                isLimitedSelected: false,
            }));
        }
    };

    handleShowAlert = (button) => {
        this.setState((prevValue) => ({
            ...prevValue,
            changeTypeVisible: !prevValue.changeTypeVisible,
        }));
        if (button) {
            this.handleSelectVoucherType(null, this.state.type, button);
        }
    };

    handleValidateSubVoucherType = () => {
        const {isBengkelSelected, isJobSelected, isPartSelected, isAllSelected} = this.state;

        const {discountUnit, discountValue} = this.props.controls;

        const error = {...this.initialErrorSubVoucher};

        error.sub =
            isBengkelSelected && !isJobSelected && !isPartSelected
                ? "Field belum diisi"
                : null;

        error.satuan =
            isAllSelected && !discountUnit?.value
                ? "Field belum diisi"
                : null;

        error.nilai =
            isAllSelected && !discountValue?.value
                ? "Field belum diisi"
                : null;
        console.log(error, 'error handleValidateSubVoucherType')
        this.setState((prev) => ({
            ...prev,
            errorsSubVoucherType: error,
        }));

        const hasErrors = Object.values(error).some((msg) => msg);
        return !hasErrors;
    };


    handleValidateVoucherAvailability = () => {
        const {isTimedSelected, isLimitedSelected} = this.state;
        const {availibilityStartDate, availibilityEndDate, maxAvailibility} = this.props.controls;

        const error = {...this.initialErrorsAvailability};

        error.startDate = isTimedSelected && !availibilityStartDate?.value ? "Field belum diisi" : null;
        error.endDate = isTimedSelected && !availibilityEndDate?.value ? "Field belum diisi" : null;
        error.maxAvailable = isLimitedSelected && !maxAvailibility?.value ? "Field belum diisi" : null;
        console.log(error, 'error handleValidateVoucherAvailability')
        this.setState((prev) => ({
            ...prev,
            errorsAvailability: error,
        }));

        const hasErrors = Object.values(error).some((msg) => msg);
        return !hasErrors;
    };


    handleSubmit = () => {
        const isValidFormGroup = this.props.validate()
        const isValidNonFormGroup = this.handleValidateSubVoucherType();
        const isValidAvailabilityForm = this.handleValidateVoucherAvailability()
        if (isValidFormGroup && isValidNonFormGroup && isValidAvailabilityForm) {
            this.props.onSubmit(this.props.controls);
        }
    };

    handleCheckIdJobPart = (rowIndex) => {
        let idJobPart = this.props.controls.spesificJobPart?.value?.[rowIndex].jobPartCode;
        let listId = this.props.controls.spesificJobPart?.value.filter((item, index) => index !== rowIndex).map(item => item.jobPartCode);
        if (!R.isNil(idJobPart)) {
            if (listId.includes(idJobPart)) {
                return this.handleDuplicateIdJobPart();
            }
            this.handleChangeSavedState(rowIndex);
        }
    };

    handleDuplicateIdJobPart = () => {
        this.setState((prevState) => ({
            ...prevState,
            alertDuplicateIdJobPart: !prevState.alertDuplicateIdJobPart,
        }))
    };

    handleRemoveRow = (rowIndex) => {
        let listJobPart = [...this.props.controls.spesificJobPart?.value];
        listJobPart.splice(rowIndex, 1);
        this.props.setValue("spesificJobPart", listJobPart);
    };

    handleChangeSavedState = (rowIndex) => {
        let updatedData = this.props.controls.spesificJobPart?.value.map((item, index) => {
            if (index === rowIndex) {
                return ({
                    ...item,
                    saved: !item.saved,
                })
            }
            return item;
        });
        this.props.setValue("spesificJobPart", updatedData);
    };

    handleAdd = () => {
        if (this.props.activityType !== ACTIVITY_TYPE.VIEW) {
            this.props.setValue("spesificJobPart", [
                ...this.props.controls.spesificJobPart.value,
                this.props.controls.subVoucherType.value === "PART"
                    ? {
                        id: null,
                        voucherWorkshopSpesificJobId: null,
                        jobPartCode: null,
                        partName: null,
                        partCategory: null,
                        unit: null,
                        value: null,
                        saved: false,
                    }
                    : null,
            ]);
        }
    };

    handleChangePart = (value, index) => {
        const selectedPart = this.props.options.partOptions.find(item => item.kodePart === value);
        let listPart = [...this.props.controls.spesificJobPart.value];
        listPart[index] = {
            ...listPart[index],
            jobPartCode: selectedPart.kodePart,
            partName: selectedPart.partName,
            partCategory: selectedPart.partCategory,
        };
        this.props.setValue("spesificJobPart", listPart);
    };

    handleChangeCategory = (value, index) => {
        const selectedCategory = this.props.options.partCategoryOptions.find(item => item.key === value);
        let listData = [...this.props.controls.spesificJobPart.value];
        const name = R.toLower(this.props.controls.subVoucherType.value) + "Category";
        console.log("name", name);
        listData[index] = {
            ...listData[index],
            [name]: selectedCategory.key,
        }
        this.props.setValue("spesificJobPart", listData);
    };

    handleChangeSatuan = (value, index) => {
        let listData = [...this.props.controls.spesificJobPart.value];
        listData[index] = {
            ...listData[index],
            unit: value,
            value: 0,
        };
        this.props.setValue("spesificJobPart", listData);
    };

    handleChangeDiscountValue = (value, index) => {
        let listData = [...this.props.controls.spesificJobPart.value];
        listData[index] = {
            ...listData[index],
            value: value,
        };
        this.props.setValue("spesificJobPart", listData);
    };

    handleStatus = (status) => {
        if (!this.state.viewOnly) {
            this.props.setValue("voucherStatus", status);
        }
    };

    render() {
        return (
            <SimpleModal
                title={"Input Data Voucher"}
                visible={this.props.visible}
                onClickClose={this.props.onClickClose}
                content={
                    <ModalContainer>
                        <div>
                            <div className="grid grid-2x gap-20px">
                                <div id="grid-1">
                                    <SimpleInput
                                        name="voucherId"
                                        label="Kode Voucher"
                                        errorMessage={this.props.errors.voucherId}
                                        value={this.props.controls.voucherId.value}
                                        onChange={({target}) => this.props.setValue(target.name, target.value)}
                                        readOnly
                                    />
                                </div>
                                <div id="grid-2">
                                    <SimpleInput
                                        name="voucherName"
                                        label="Nama Voucher"
                                        mandatory={!this.state.viewOnly}
                                        errorMessage={this.props.errors.voucherName}
                                        value={this.props.controls.voucherName.value}
                                        onChange={({target}) => this.props.setValue(target.name, target.value)}
                                        readOnly={this.state.viewOnly}
                                    />
                                </div>
                            </div>
                            <div className="grid grid-2x gap-20px">
                                <div id="grid-1">
                                    <FlexView style={{alignItems: "center", gap: "20px"}}>
                                        <SimpleInput
                                            box="number"
                                            name="validityPeriod"
                                            label="Masa Berlaku"
                                            mandatory={!this.state.viewOnly}
                                            errorMessage={this.props.errors.validityPeriod}
                                            value={this.props.controls.validityPeriod.value}
                                            onValueChange={({value}) => this.props.setValue("validityPeriod", value)}
                                            readOnly={this.state.viewOnly}
                                        />
                                        <div className="txt-site txt-12 txt-main txt-bold">
                                            <h4>Hari</h4>
                                        </div>
                                    </FlexView>
                                    <div>
                                        <div className="txt-site txt-11 txt-main txt-bold">
                                            <h4>
                                                Jenis Voucher {!this.state.viewOnly &&
                                                <span style={{color: 'red'}}>*</span>}
                                            </h4>
                                        </div>
                                        <FlexView style={{gap: "20px", marginRight: "20px"}}>
                                            <SimpleCheckBox
                                                id="voucherUndian"
                                                key="voucherUndian"
                                                name="voucherUndian"
                                                label="UNDIAN"
                                                checked={this.state.isUndianSelected}
                                                mandatory={!(this.state.isUndianSelected || this.state.isBengkelSelected) && !this.state.viewOnly}
                                                errorMessage={this.props.errors.voucherType}
                                                onChange={(e) => this.handleSelectVoucherType(e, "UNDIAN", false)}
                                                disabled={this.state.viewOnly}
                                            />
                                            <SimpleCheckBox
                                                id="voucherBengkel"
                                                key="voucherBengkel"
                                                name="voucherBengkel"
                                                label="BENGKEL"
                                                checked={this.state.isBengkelSelected}
                                                mandatory={!(this.state.isUndianSelected || this.state.isBengkelSelected) && !this.state.viewOnly}
                                                errorMessage={this.props.errors.voucherType}
                                                onChange={(e) => this.handleSelectVoucherType(e, "BENGKEL", false)}
                                                disabled={this.state.viewOnly}
                                            />
                                        </FlexView>
                                        {this.props.errors.voucherType &&
                                            <p className="txt-site txt-11 color-red margin-top-5px">{this.props.errors.voucherType}</p>}
                                    </div>
                                    {this.state.isJobSelected && (
                                        <div style={{marginTop: "20px"}}>
                                            <div className="txt-site txt-11 txt-main txt-bold">
                                                <h4>
                                                    Daftar Job {!this.state.viewOnly &&
                                                    <span style={{color: 'red'}}>*</span>}
                                                </h4>
                                            </div>
                                            <FlexView style={{gap: "20px", marginRight: "20px"}}>
                                                <SimpleCheckBox
                                                    id="allJob"
                                                    key="allJob"
                                                    name="allJob"
                                                    label="All Job"
                                                    checked={this.state.isAllSelected}
                                                    mandatory={this.state.isBengkelSelected && this.state.isJobSelected && !this.state.viewOnly}
                                                    errorMessage={this.props.errors.applicableJob}
                                                    onChange={(e) => this.handleSelectAppliedSubType(e, "ALL")}
                                                    disabled={this.state.viewOnly}
                                                />
                                                <SimpleCheckBox
                                                    id="specificJob"
                                                    key="specificJob"
                                                    name="specificJob"
                                                    label="Spesifik Job"
                                                    checked={this.state.isSpecificSelected}
                                                    mandatory={this.state.isBengkelSelected && this.state.isJobSelected && !this.state.viewOnly}
                                                    errorMessage={this.props.errors.applicableJob}
                                                    onChange={(e) => this.handleSelectAppliedSubType(e, "SPESIFIK")}
                                                    disabled={this.state.viewOnly}
                                                />
                                            </FlexView>
                                        </div>
                                    )}
                                    {this.state.isPartSelected && (
                                        <div style={{marginTop: "20px"}}>
                                            <div className="txt-site txt-11 txt-main txt-bold">
                                                <h4>
                                                    Daftar Part {!this.state.viewOnly &&
                                                    <span style={{color: 'red'}}>*</span>}
                                                </h4>
                                            </div>
                                            <FlexView style={{gap: "20px", marginRight: "20px"}}>
                                                <SimpleCheckBox
                                                    id="allPart"
                                                    key="allPart"
                                                    name="allPart"
                                                    label="All Part"
                                                    checked={this.state.isAllSelected}
                                                    mandatory={this.state.isBengkelSelected && this.state.isPartSelected && !this.state.viewOnly}
                                                    errorMessage={this.props.errors.applicableJob}
                                                    onChange={(e) => this.handleSelectAppliedSubType(e, "ALL")}
                                                    disabled={this.state.viewOnly}
                                                />
                                                <SimpleCheckBox
                                                    id="specificPart"
                                                    key="specificPart"
                                                    name="specificPart"
                                                    label="Spesifik Part"
                                                    checked={this.state.isSpecificSelected}
                                                    mandatory={this.state.isBengkelSelected && this.state.isPartSelected && !this.state.viewOnly}
                                                    errorMessage={this.props.errors.applicableJob}
                                                    onChange={(e) => this.handleSelectAppliedSubType(e, "SPESIFIK")}
                                                    disabled={this.state.viewOnly}
                                                />
                                            </FlexView>
                                        </div>
                                    )}
                                </div>
                                <div id="grid-2">
                                    <FlexView style={{alignItems: "center", gap: "20px"}}>
                                        <SimpleInput
                                            box="number"
                                            name="pricePoint"
                                            label="Harga"
                                            mandatory={!this.state.viewOnly}
                                            errorMessage={this.props.errors.pricePoint}
                                            value={this.props.controls.pricePoint.value}
                                            onValueChange={({value}) => this.props.setValue("pricePoint", value)}
                                            readOnly={this.state.viewOnly}
                                        />
                                        <div className="txt-site txt-12 txt-main txt-bold">
                                            <h4>Point</h4>
                                        </div>
                                    </FlexView>
                                    {this.state.isBengkelSelected && (
                                        <div>
                                            <div className="txt-site txt-11 txt-main txt-bold">
                                                <h4>
                                                    Sub Jenis Voucher Bengkel {!this.state.viewOnly &&
                                                    <span style={{color: 'red'}}>*</span>}
                                                </h4>
                                            </div>
                                            <FlexView style={{gap: "20px", marginRight: "20px"}}>
                                                <SimpleCheckBox
                                                    id="job"
                                                    key="job"
                                                    name="job"
                                                    label="JOB"
                                                    checked={this.state.isJobSelected}
                                                    mandatory={this.state.isBengkelSelected && !(this.state.isJobSelected || this.state.isPartSelected) && !this.state.viewOnly}
                                                    errorMessage={this.props.errors.subVoucherType}
                                                    onChange={(e) => this.handleSelectVoucherSubType(e, "JOB")}
                                                    disabled={this.state.viewOnly}
                                                />
                                                <SimpleCheckBox
                                                    id="part"
                                                    key="part"
                                                    name="part"
                                                    label="PART"
                                                    checked={this.state.isPartSelected}
                                                    mandatory={this.state.isBengkelSelected && !(this.state.isJobSelected || this.state.isPartSelected) && !this.state.viewOnly}
                                                    errorMessage={this.props.errors.subVoucherType}
                                                    onChange={(e) => this.handleSelectVoucherSubType(e, "PART")}
                                                    disabled={this.state.viewOnly}
                                                />
                                            </FlexView>
                                            {this.state.isBengkelSelected && this.state.errorsSubVoucherType.sub &&
                                                <p className="txt-site txt-11 color-red margin-top-5px">{this.state.errorsSubVoucherType.sub}</p>}
                                        </div>
                                    )}
                                    {this.state.isAllSelected && (
                                        <div className="grid grid-2x gap-20px">
                                            <div id="grid-1">
                                                <SimpleDDL
                                                    id="select_options_satuan"
                                                    box="search"
                                                    name="discountUnit"
                                                    label="Satuan"
                                                    errorMessage={this.props.errors.discountUnit}
                                                    value={this.props.controls.discountUnit.value}
                                                    mandatory={this.state.isAllSelected && !this.state.viewOnly}
                                                    options={this.state.satuanOptions}
                                                    onChange={(value, {name}) => this.props.setValue(name, value)}
                                                    readOnly={this.state.viewOnly}
                                                />
                                                {this.state.isAllSelected && this.state.errorsSubVoucherType.satuan &&
                                                    <p className="txt-site txt-11 color-red margin-top-5px">{this.state.errorsSubVoucherType.satuan}</p>}
                                            </div>
                                            <div id="grid-2">
                                                <SimpleInput
                                                    name="discountValue"
                                                    label="Nilai"
                                                    box="number"
                                                    errorMessage={this.props.errors.discountValue}
                                                    value={this.props.controls.discountValue.value}
                                                    mandatory={this.state.isAllSelected && !this.state.viewOnly}
                                                    onValueChange={({value}) => this.props.setValue("discountValue", value)}
                                                    readOnly={this.state.viewOnly}
                                                />
                                                {this.state.isAllSelected && this.state.errorsSubVoucherType.nilai &&
                                                    <p className="txt-site txt-11 color-red margin-top-5px">{this.state.errorsSubVoucherType.nilai}</p>}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                            {this.state.isSpecificSelected && (
                                <FlexView column style={{marginTop: "20px"}}>
                                    {!this.state.viewOnly && (
                                        <SimpleButton
                                            onClick={this.handleAdd}
                                            styles={{marginBottom: "20px"}}
                                        >Tambah</SimpleButton>
                                    )}
                                    <SimpleDataTable
                                        data={this.props.controls.spesificJobPart.value}
                                        columns={this.state.tableConfig}
                                        options={{serverSide: false}}
                                        rowsPerPage={5}
                                        errorMessage={this.props.errors.spesificJobPart}
                                        mandatory={this.state.isSpecificSelected && !this.state.viewOnly}
                                    />
                                </FlexView>
                            )}
                            <div style={{marginTop: "20px"}}>
                                <div className="txt-site txt-11 txt-main txt-bold">
                                    <h4>
                                        Availability {!this.state.viewOnly && <span style={{color: 'red'}}>*</span>}
                                    </h4>
                                </div>
                                <FlexView style={{gap: "20px", marginRight: "20px"}}>
                                    <SimpleCheckBox
                                        id="timed"
                                        key="timed"
                                        name="TIMED"
                                        label="TIMED"
                                        checked={this.state.isTimedSelected}
                                        onChange={(e) => this.handleAvailability(e, "TIMED")}
                                        disabled={this.state.viewOnly}
                                    />
                                    <SimpleCheckBox
                                        id="limited"
                                        key="limited"
                                        name="limited"
                                        label="LIMITED"
                                        checked={this.state.isLimitedSelected}
                                        onChange={(e) => this.handleAvailability(e, "LIMITED")}
                                        disabled={this.state.viewOnly}
                                    />
                                    <SimpleCheckBox
                                        id="unlimited"
                                        key="unlimited"
                                        name="unlimited"
                                        label="UNLIMITED"
                                        checked={this.state.isUnlimitedSelected}
                                        onChange={(e) => this.handleAvailability(e, "UNLIMITED")}
                                        disabled={this.state.viewOnly}
                                    />
                                </FlexView>
                                {this.props.errors.availibilityVoucher &&
                                    <p className="txt-site txt-11 color-red margin-top-5px">{this.props.errors.availibilityVoucher}</p>}
                            </div>
                            <div className="grid grid-2x gap-20px" style={{marginTop: "20px"}}>
                                <div id="grid-1">
                                    <SimpleDate
                                        id="select_date_start_period"
                                        name="availibilityStartDate"
                                        label="Start Periode Availability"
                                        mandatory={this.state.isTimedSelected && !this.state.viewOnly}
                                        errorMessage={this.state.errorsAvailability.startDate}
                                        nextdate
                                        date={this.props.controls.availibilityStartDate.value || null}
                                        maxDate={this.props.controls.availibilityEndDate.value || M(Date.now()).format("DD-MM-YYYY")}
                                        onChange={(value) => this.props.setValue("availibilityStartDate", M(value).format("DD-MM-YYYY"))}
                                        disabled={this.state.viewOnly}
                                    />
                                    <SimpleInput
                                        name="maxAvailibility"
                                        label="Max Available"
                                        mandatory={this.state.isLimitedSelected && !this.state.viewOnly}
                                        errorMessage={this.state.errorsAvailability.maxAvailable}
                                        box="number"
                                        value={this.props.controls.maxAvailibility.value}
                                        onValueChange={({value}) => this.props.setValue("maxAvailibility", value)}
                                        readOnly={this.state.viewOnly}
                                    />
                                    <FlexView>
                                        <div className="txt-site txt-11 txt-main txt-bold margin-right-20px">
                                            <h4>
                                                Status {!this.state.viewOnly && <span style={{color: 'red'}}>*</span>}
                                            </h4>
                                        </div>
                                        <ToggleButton
                                            name="voucherStatus"
                                            label="Status"
                                            mandatory
                                            errorMessage={this.props.errors.voucherStatus}
                                            value={R.equals(
                                                this.props.controls.voucherStatus.value,
                                                Status.ACTIVE
                                            )}
                                            onToggle={(value) =>
                                                this.handleStatus(!value ? Status.ACTIVE : Status.INACTIVE)
                                            }
                                        />
                                    </FlexView>
                                </div>
                                <div id="grid-2">
                                    <SimpleDate
                                        id="select_date_end_period"
                                        name="availibilityEndDate"
                                        label="End Periode Availability"
                                        mandatory={this.state.isTimedSelected && !this.state.viewOnly}
                                        errorMessage={this.state.errorsAvailability.endDate}
                                        backdate
                                        date={this.props.controls.availibilityEndDate.value || null}
                                        minDate={this.props.controls.availibilityStartDate.value || M(Date.now()).format("DD-MM-YYYY")}
                                        onChange={(value) => this.props.setValue("availibilityEndDate", M(value).format("DD-MM-YYYY"))}
                                        disabled={this.state.viewOnly}
                                    />
                                    <SimpleUploadImage
                                        id="input_upload_foto_voucher"
                                        name="voucherPictureBase64"
                                        label="Gambar Voucher"
                                        mandatory={!this.state.viewOnly}
                                        errorMessage={this.props.errors.voucherPictureBase64}
                                        value={this.props.controls.voucherPictureBase64.value}
                                        onChange={(value, name) => this.props.setValue(name, value)}
                                        category={this.state.viewOnly ? "" : "upload"}
                                    />
                                </div>
                            </div>
                            {!this.state.viewOnly && (
                                <FlexView style={{justifyContent: "center", marginTop: "50px"}}>
                                    <SimpleButton onClick={this.handleSubmit}>Simpan</SimpleButton>
                                </FlexView>
                            )}
                        </div>
                        {this.state.changeTypeVisible && (
                            <SimpleAlert
                                visible={this.state.changeTypeVisible}
                                onClickClose={this.handleShowAlert}
                                content={
                                    <div>
                                        <p>Apakah Anda yakin ingin mengganti</p>
                                        <p>tipe Voucher? Data yang diisi</p>
                                        <p>sebelumnya akan hilang.</p>
                                    </div>
                                }
                                additionalButtons={
                                    <FlexView vAlignContent="center" style={{gap: "10px"}}>
                                        <SimpleButton secondary onClick={() => this.handleShowAlert()}>
                                            Batal
                                        </SimpleButton>
                                        <SimpleButton onClick={() => this.handleShowAlert(true)}>
                                            OK</SimpleButton>
                                    </FlexView>
                                }
                            />
                        )}
                        {this.props.errorNameVisible && (
                            <SimpleAlert
                                visible={this.props.errorNameVisible}
                                onClickClose={this.props.onClickOkError}
                                content={
                                    <div>
                                        <p>Terdapat nama voucher yang</p>
                                        <p>sama, silahkan cek kembali.</p>
                                    </div>
                                }
                                additionalButtons={
                                    <FlexView vAlignContent="end" style={{gap: "10px"}}>
                                        <SimpleButton onClick={this.props.onClickOkError}>
                                            OK</SimpleButton>
                                    </FlexView>
                                }
                            />
                        )}
                        {this.state.alertDuplicateIdJobPart && (
                            <SimpleAlert
                                title={"Peringatan"}
                                content={`${this.props.controls.subVoucherType.value === "PART" ? "No Part" : "Kode Job"} sudah terdapat pada list. Mohon dicek kembali`}
                                visible={this.state.alertDuplicateIdJobPart}
                                onClickClose={this.handleDuplicateIdJobPart}
                                additionalButtons={
                                    <SimpleButton
                                        type="button"
                                        text="OK"
                                        onClick={this.handleDuplicateIdJobPart}
                                    />
                                }
                            />
                        )}
                    </ModalContainer>
                }
            />
        )
    }
}

export default withFormGroup(MasterVoucherModifying);